// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShopOutlinedSvg from "@fishx/icons-svg/es/asn/ShopOutlined";
import FishxIcon from '../components/FishxIcon';

var ShopOutlined = function ShopOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShopOutlinedSvg
  }));
};

ShopOutlined.displayName = 'ShopOutlined';
export default React.forwardRef(ShopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ShopOutlined.js
// module id = 4104
// module chunks = 0